import { Component, Input } from '@angular/core';
import { MijnProfiel, Profiel } from '../../model/profiel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ActiefTeamlidDto,
  ActieveJongereDto,
  ProfielCreateOption,
  Rol,
  UitgenodigdTeamlidDto,
} from 'parkour-web-app-dto';
import {
  ParkourButtonComponent,
  ParkourDividerComponent,
  ParkourPageImageComponent,
} from '@parkour/ui';
import { ProfielFotoPipe } from '../../../shared/pipes/profiel-foto.pipe';
import { AsyncPipe, NgClass } from '@angular/common';
import { ProfielFotoComponent } from '../../../shared/components/profiel-foto/profiel-foto.component';
import { ProfielnaamPipe } from '../../../shared/pipes/profielnaam.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { HttpLinkPipe } from '../../../shared/pipes/http-link.pipe';
import { ProfileDetailsListItemComponent } from '../profile-details-list-item/profile-details-list-item.component';
import { ProfielDetailsCardComponent } from '../profiel-details-card/profiel-details-card.component';

export type ProfielDetailsMode =
  | {
      type: 'JONGERE';
      profielen: Profiel[];
      profielCreateOptions: ProfielCreateOption[];
    }
  | {
      type: 'TEAMEIGENAAR';
    }
  | {
      type: 'TEAMLID';
      initialRol: Rol;
      editable: boolean;
    };

@Component({
  standalone: true,
  selector: 'parkour-profiel-details',
  templateUrl: './profiel-details.component.html',
  imports: [
    ParkourPageImageComponent,
    ProfielFotoPipe,
    AsyncPipe,
    ProfielFotoComponent,
    ProfielnaamPipe,
    FormsModule,
    TranslateModule,
    ParkourDividerComponent,
    ParkourButtonComponent,
    HttpLinkPipe,
    NgClass,
    ReactiveFormsModule,
    ProfileDetailsListItemComponent,
    ProfielDetailsCardComponent,
  ],
})
export class ProfielDetailsComponent {
  @Input({ required: true }) profiel!:
    | MijnProfiel
    | UitgenodigdTeamlidDto
    | ActiefTeamlidDto
    | ActieveJongereDto;

  getVisualLink(link: string) {
    return link.replace('www.', '').replace('http://', '').replace('https://', '');
  }
}
